import type { ReactNode } from "react";
import ResultsLoader from "../ResultsLoader/ResultsLoader";
import { StyledView } from "./styles";

type Props = {
    isLoading: boolean;
    children: NonNullable<ReactNode>;
    className?: string;
};

const ContentView = ({ className, isLoading, children }: Props) => {
    if (isLoading) {
        return <ResultsLoader />;
    }

    return (
        <StyledView
            className={className}
            data-automation="content-view"
        >
            {children}
        </StyledView>
    );
};

export default ContentView;
